<template>
  <section class="simulados pt-5 pb-5">
    <div class="simulado-novo box-branco container">
      <h2><i class="fas fa-list-ul"></i>Escolha o tipo de simulado que quer fazer</h2>
      <div class="row escolher-sim">
        <div class="col-12 col-md-6">
          <div class="sim-opcao sim-pratica" @click="criarSimuladoParaUsuario(tipoPraticaTreino)">
            <img :src="require('@/assets/img/sim-pratica.png')" :alt="$t('simulados.modotreinoimagemalt')" />
            <h3>{{ $t('simulados.modotreino') }}</h3>
            <p>{{ $t('simulados.modotreinodescricao') }}</p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="sim-opcao sim-prova" @click="criarSimuladoParaUsuario(tipoPraticaProva)">
            <img :src="require('@/assets/img/sim-prova.png')" :alt="$t('simulados.modoprovaimagemalt')" />
            <h3>{{ $t('simulados.modoprova') }}</h3>
            <p>{{ $t('simulados.modoprovadescricao') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TipoPraticaSimulado from '@/core/types/tipo-pratica-simulado'
import SimuladoAPI from '@/api/simulado-api'
import ResponseUtils from '@/core/utils/response-utils'

export default {
  name: 'SimuladoModoView',

  data () {
    return {
      tipoPraticaTreino: TipoPraticaSimulado.TREINO.id,
      tipoPraticaProva: TipoPraticaSimulado.PROVA.id
    }
  },

  methods: {
    criarSimuladoParaUsuario: function (tipoPratica) {
      const idSimulado = this.$route.params.simulado

      const loader = this.$loading.show()

      SimuladoAPI.criarSimuladoUsandoModelo(idSimulado).then(data => {
        if (data.data && data.data.pratica) {
          window.location = `/simulados/prova/${data.data.pratica}`
        } else {
          loader.hide()
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  }
}
</script>

<style scoped>

</style>
